import React from 'react'
import type { StyleProp } from '@vtex/admin-ui'
import { Button, ModalFooter, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

const modalFooterStyles: StyleProp = {
  justifyContent: 'flex-end',
  paddingX: '$space-5',
  paddingY: '$space-3',
}

export type SalesAssociateMovementsTrackingModalFooterProps = {
  onCancelClick: () => void
  onConfirmClick: () => void
  shouldDisableConfirmButton?: boolean
}

export const SalesAssociateMovementsTrackingModalFooter = ({
  onCancelClick,
  onConfirmClick,
  shouldDisableConfirmButton,
}: SalesAssociateMovementsTrackingModalFooterProps) => {
  const intl = useIntl()

  return (
    <ModalFooter className={csx({ ...modalFooterStyles })}>
      <Button
        variant="secondary"
        onClick={onCancelClick}
        data-testid="occurrences-modal-cancel"
      >
        {intl.messages.cancel}
      </Button>
      <Button disabled={shouldDisableConfirmButton} onClick={onConfirmClick}>
        {intl.messages.conclude}
      </Button>
    </ModalFooter>
  )
}
